import Avatar from '../Avatar/Avatar';
import React from 'react';

import styles from './PersonCard.module.scss';

import hiddenImgSrc from '../../assets/wedding-party/hidden.webp';

const capitalizeFirstLetter = (val) => {
    return String(val).charAt(0).toUpperCase() + String(val).slice(1);
}

const randomName = () => {
    const generateName = (length) => {
        let result = '';
        const characters = 'абвгдежзийклмнопрстуфхцчшщьюя';
        const charactersLength = characters.length;
        let counter = 0;
        while (counter < length) {
          result += characters.charAt(Math.floor(Math.random() * charactersLength));
          counter += 1;
        }

        return capitalizeFirstLetter(result);
    }
    
    return `${generateName(Math. random() * (10 - 5) + 5)} ${generateName(Math. random() * (10 - 6) + 6)}`;
}

const PersonCard = ({imageSrc, name, description = '', className = '', simple = false, size = 'large', hide = false}) => {
    const imageSize = size === 'large' ? 250 : 200;

    return (
        <div className={`${styles.container} ${simple ? styles.simple : ''} ${className}`}>
            <Avatar src={hide ? hiddenImgSrc : imageSrc} primary width={imageSize} />
            <div className={`${styles.content} ${hide && styles.hide}`}>
                <h3>{hide ? randomName() : name}</h3>
                {description ? <p>{hide ? 'Искаш да измамиш и да видиш предварително. Обаче сме помислили за това. Имай търпение!' : description}</p> : undefined}
            </div>
        </div>
    )
}

export default PersonCard;